import React, { useEffect, useState } from 'react';
import api from '../../../../api';

const Alasca = () => {
  const [aboutSection, setAboutSection] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const aboutContent = async () => {
      try {
        const response = await api.get("/api/sitepages/alumni/alasca");
        const data = response.data;

        if (data && data.content) {
          setAboutSection(data.content);
        }
      } catch (error) {
        console.error("Error fetching About Content:", error);
      } finally {
        setLoading(false);
      }
    };

    aboutContent();
  }, []);

  if (loading) {
    return <></>;
  }

  return (
    <>
      {/* Desktop View */}
      <div id="wrapper" className="d-none d-lg-block">
        <div id="container">
          <div className="row pt-5">
            <div className="alumni_side">
              <h3>
                ALASCA (Alumni Association of CARE)
              </h3>
            </div>
          </div>

          <section className="open-book">
            <article>
             <h2
                className="chapter-title"

              >
                About
              </h2>
              <div

                dangerouslySetInnerHTML={{
                  __html: aboutSection?.about || "<p>No About content available.</p>",
                }}
              />

                <h2
                className="chapter-title"

              >
                Aims and Objectives
              </h2>
              <div


                dangerouslySetInnerHTML={{
                  __html:
                    aboutSection?.aims_objectives ||
                    "<p>No Aims & Objectives content available.</p>",
                }}
              />
            </article>
            <footer>
              <ol id="page-numbers">
                <li>
                  1
                </li>
                <li >
                  2
                </li>
              </ol>
            </footer>
          </section>
        </div>
      </div>

      {/* Mobile View - Part 1 */}
      <div id="wrapper" className="d-block d-lg-none">
        <div id="container">
          <div className="row pt-3">
            <div className="alumni_side">
              <h3 >
                ALASCA (Alumni Association of CARE)
              </h3>
            </div>
          </div>

          <section className="open-book">
            <article>
              <h2
                className="chapter-title"

              >
                About
              </h2>
              <div

                dangerouslySetInnerHTML={{
                  __html: aboutSection?.about || "<p>No About content available.</p>",
                }}
              />
            </article>
          </section>
        </div>
      </div>

      {/* Mobile View - Part 2 */}
      <div id="wrapper" className="pt_80 d-block d-lg-none">
        <div id="container">
          <section className="open-book">
            <article>
              <h2
                className="chapter-title"

              >
                Aims and Objectives
              </h2>
              <div

                dangerouslySetInnerHTML={{
                  __html:
                    aboutSection?.aims_objectives ||
                    "<p>No Aims & Objectives content available.</p>",
                }}
              />
            </article>
          </section>
        </div>
      </div>
    </>
  );
};

export default Alasca;